/**
 * Installs the app's Trusted Types `default` policy before anything else runs. The
 * Content-Security-Policy (securityHeaders.ts) requires Trusted Types, so a string can
 * only become a script URL through here, and only if it is same-origin - which is what
 * creating the database worker needs. The policy has no `createHTML`: HTML must come
 * from DOMPurify's own policy (sanitize.ts), so any other innerHTML-style write throws.
 */
interface TrustedTypePolicyFactoryLike {
  createPolicy(name: string, rules: { createScriptURL(input: string): string }): unknown;
}

const factory = (globalThis as { trustedTypes?: TrustedTypePolicyFactoryLike }).trustedTypes;

if (factory) {
  factory.createPolicy('default', {
    createScriptURL(input: string): string {
      const url = new URL(input, document.baseURI);
      if (url.origin !== window.location.origin) {
        throw new TypeError(`Blocked a script from another origin: ${url.origin}`);
      }
      return url.href;
    },
  });
}

export {};
